/**
 * work-tasks-performance F21 — идентификатор ВКЛАДКИ для фильтра собственного эха.
 *
 * ПОЧЕМУ MODULE-SCOPE, А НЕ localStorage `[П20]`. Вкладки не делят соединение и не
 * делят мутации: сохранённый в хранилище id был бы общим на все вкладки, и правка
 * в одной глушила бы обновление в другой — та не узнала бы о чужом изменении,
 * считая его своим. Здесь id живёт ровно столько, сколько живёт вкладка.
 *
 * Заголовок `X-Client-Id` уезжает со всеми мутациями task-модуля, бэкенд кладёт
 * его в событие как `origin_client_id` (B13), а стрим по нему отличает своё эхо
 * от чужой правки.
 */
export const TAB_CLIENT_ID: string =
  typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `00000000-0000-4000-8000-${Date.now().toString(16).padStart(12, '0').slice(-12)}`;
